<template>
  <v-select
    v-if="projectSelectedRevision(parameter)"
    v-model="selectedRevision"
    :items="revisionSet"
    return-object
    color="primary"
    @click.stop
    hide-details
    item-title="name"
    filled
    item-text="id"
  >
    <template v-slot:append-item>
      <v-divider class="mt-1"></v-divider>
      <div class="append ma-1 mb-0">
        <v-btn class="append" variant="text" style="width: 100%" @click="toggleRevisionDialog">
          Add revision
        </v-btn>
      </div>
    </template>
  </v-select>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'RevisionSelect',
  props: {
    storeNamespace: {},
    parameter: {}
  },
  computed: {
    ...mapState('project', {
      currentProject: (state) => state.currentProject
    }),
    ...mapGetters('project', {
      projectSelectedRevision: 'selectedRevision',
      parameterSetName: 'parameterSetName'
    }),
    revisionSet() {
      const parameterSetName = this.parameterSetName(this.parameter)
      return this.currentProject[parameterSetName]
    },
    selectedRevision: {
      get() {
        const revisionId = this.$route.params.revisionId
        return revisionId
          ? this.revisionSet.find((revision) => revision.id === parseInt(revisionId))
          : this.projectSelectedRevision(this.parameter)
      },
      async set(value) {
        this.setSelectedRevision({ parameter: this.parameter, payload: value.id })
        await this.$store.dispatch(this.storeNamespace + '/updateSelectedRevision', {
          id: this.currentProject.currentprojectuser.id,
          parameter: this.parameter,
          selectedRevision: this.projectSelectedRevision(this.parameter)
        })
        const tab = this.$route.query.tab ?? null
        const query = tab ? { tab: tab } : {}
        await this.$router.replace({ params: { revisionId: value.id }, query })
        await this.$emit('update')
      }
    }
  },
  methods: {
    toggleRevisionDialog() {
      this.$store.dispatch(this.storeNamespace + '/toggleRevisionDialog')
    },
    ...mapActions('project', {
      setSelectedRevision: 'setSelectedRevision'
    })
  }
}
</script>
<style scoped>
.append {
  position: sticky;
  display: flex;
  justify-content: center;
  background: white;
}
</style>
